import * as React from 'react';
import * as Glob from '../Globale';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad } from '../components/';

interface IDatiProfessionaliProps extends Dati.IBaseProps {
    Parametri: Glob.DatiJSON;
    Dati: Glob.DatiJSON;
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label: string, fieldTypeId: number, elementGroup?: any) => any;
}

export class DatiProfessionali extends BasePureComponent<IDatiProfessionaliProps, {}> {
    private _Parametri: Dati.CCampoStruttura[] = [];
    private _Dati: Dati.CDictionary<any> = new Dati.CDictionary<any>();

    constructor(props: any) {
        super(props);
        this.OnAggiorna = this.OnAggiorna.bind(this);
    }

    private Inizializza(props: IDatiProfessionaliProps) {
        if (typeof (props.Parametri) == "string") {
            this._Parametri = JSON.parse(props.Parametri);
        } else {
            this._Parametri = props.Parametri;
        }

        if (this.props.Dati != undefined && this.props.Dati != "") {
            if (typeof (props.Dati) == "string") {
                this._Dati.LoadFromJSON(props.Dati);
            } else {
                this._Dati = props.Dati;
            }
        } else {
            this._Dati = new Dati.CDictionary<any>();
            for (let x: number = 0; x < this._Parametri.length; x++) {
                this._Dati.Add(this._Parametri[x].Campo, "");
            }
        }
    }

    private PopolaValori(): any {
        let gruppo: any[] = [];
        for (let x: number = 0; x < this._Parametri.length; x++) {
            let dato: Dati.CCampoDato = new Dati.CCampoDato();
            dato.Campo = this._Parametri[x].Campo;
            dato.Valore = this._Dati.Item(this._Parametri[x].Campo);
            gruppo.push(Glob.GetComponente(x.toString(), this._Parametri[x], dato, this.OnAggiorna));
        }
        return gruppo;
    }

    private OnAggiorna(e: React.FormEvent<any> | string, valore: any): void {
        let Valore: any;
        let Campo: string;

        let app: string[] = [];

        if (typeof (e) == "string") {
            app = e.split("_");
            Campo = e.replace("_" + app[app.length - 1], "");
            Valore = valore;
        } else {
            app = e.currentTarget.name.split("_");
            Campo = e.currentTarget.name.replace("_" + app[app.length - 1], "");
            Valore = e.currentTarget.value;
        }

        this._Dati.Set(Campo, Valore);
        this.props.OnChange(this.props.Name, this._Dati.GetJSON());
        if(this.props.OnChangeAppendice) {
            this.props.OnChangeAppendice(`${this.props.Name}.${Campo}`, Valore, Campo, Campo === 'NumeroIscrizione' ? 2 : 1);
        }
    }

    public render() {
        this.Inizializza(this.props);
        return <div className={"kt-portlet bg-fill-accent kt-portlet--head-solid-bg kt-portlet--bordered " + this.props.CSS}>
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-marker"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("DatiProfessionali")}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                </div>
            </div>
            <div className="kt-portlet__body">
                <div className="form-group kt-form login-form__group row">
                    {this.PopolaValori()}
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/DatiProfessionali.tsx